import { c as _c } from "react/compiler-runtime";
import { ageList } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/passenger-room-count-input/passenger-room-count-tour/constant";
import { usePassengerRoomCountTour } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/passenger-room-count-input/passenger-room-count-tour/hooks";
import styles from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/passenger-room-count-input/passenger-room-count-tour/passenger-room-count-tour.module.scss";
import { PassengerRoomCountTourPropertiesType } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/passenger-room-count-input/passenger-room-count-tour/types";
import { useViewPort } from "@website/hooks/viewport";
import { ArrowDropDown } from "@website/icons/components/arrow-drop-down";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Chips } from "@website/ui/chips";
import { Dropdown } from "@website/ui/dropdown";
import { ListItem } from "@website/ui/list-item";
import { MiniChips } from "@website/ui/mini-chips";
import { MiniPopover } from "@website/ui/mini-popover";
import { numberConvert } from "@website/utils/number-convert";
import { ChangeEvent, FC, useEffect, useState } from "react";
const toFarsi = (value: number) => numberConvert(value, {
  locale: "fa"
});
const child_age_is_mandatory = "سن کودک اجباری است";
const child_age = (age: number) => `سن کودک ${toFarsi(age)}`;
const add_room = "افزودن اتاق";
const valid_passenger_count = (count: number) => `سقف تعداد مسافر ${toFarsi(count)} نفر می باشد.`;
const valid_max_adult_count = (count: number) => `سقف تعدا بزرگسال و کودک برای هر اتاق ${toFarsi(count)} نفر میباشد`;
const valid_max_room_count = (count: number) => `سقف تعداد اتاق ${toFarsi(count)} است.`;

//TODO: Must import css as classname , I comment onChange because does not make sense
export const PassengerRoomCountTour: FC<PassengerRoomCountTourPropertiesType> = properties => {
  const $ = _c(46);
  const [adultWarningIsShow, setAdultWarningIsShow] = useState(false);
  const {
    list,
    chipsProps,
    popoverProps,
    submitButtonProps,
    submitText
  } = usePassengerRoomCountTour(properties);
  const {
    onDelete,
    onAdd,
    onChangeChildAge,
    list: listItems,
    totalPassenger
  } = properties;
  const {
    isMobile
  } = useViewPort();
  let t0;
  if ($[0] !== listItems) {
    t0 = () => {
      for (const [_, item] of listItems.entries()) {
        if (item?.children?.[0]?.value?.length + item?.children?.[1]?.value?.length > 5) {
          setAdultWarningIsShow(true);
          break;
        } else {
          setAdultWarningIsShow(false);
        }
      }
    };
    $[0] = listItems;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== list || $[3] !== listItems) {
    t1 = [list, listItems];
    $[2] = list;
    $[3] = listItems;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] !== chipsProps) {
    t2 = <Chips {...chipsProps} />;
    $[5] = chipsProps;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== isMobile || $[8] !== list || $[9] !== listItems || $[10] !== onChangeChildAge || $[11] !== onDelete) {
    t3 = list?.map((items, itemsIndex) => <div key={items?.id}><div className={styles.header}><span className={styles.title}>{`${items?.title} ${numberConvert(itemsIndex + 1, {
            locale: "fa"
          })}`}</span>{list?.length > 1 && <Button EndIcon={<MaterialIcon name="delete_outline" />} className={styles["delete"]} color="neutral" onClick={() => onDelete(items?.id)} text={"\u062D\u0630\u0641"} variant="text" />}</div><div>{items?.children?.map(_temp)}</div><div className={styles["dropwdown-box"]}>{listItems[itemsIndex]?.children?.[1]?.value?.map((item_1, index) => <div className={styles["dropwdown-item"]} key={item_1?.title}>{isMobile ? <Dropdown error={!item_1} fullWidth={true} label={child_age(index + 1)} list={ageList} name="gender" onChange={value => onChangeChildAge(value, itemsIndex, index)} value={`${item_1}` || ""} /> : <div className={`${styles["select-box"]} ${item_1 === undefined ? styles.error : ""}`}><div className={`${styles["end-icon"]} ${item_1 === undefined ? styles.error : ""}`}><ArrowDropDown /></div><select className={styles.select} name="gender" onChange={event => {
              onChangeChildAge(event.target.value, itemsIndex, index);
            }} value={item_1}><option className={styles["none-option"]} key="0" value="0" />{ageList?.map(_temp2)}</select><label className={`${item_1 ? styles["label-selected-value"] : item_1 === undefined ? `${styles.label} ${styles.error}` : styles.label}`}>{child_age(index + 1)}</label></div>}{item_1 === undefined && <div className={styles.error}>{child_age_is_mandatory}</div>}</div>)}</div></div>);
    $[7] = isMobile;
    $[8] = list;
    $[9] = listItems;
    $[10] = onChangeChildAge;
    $[11] = onDelete;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MaterialIcon name="add" />;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const t5 = list.length > 5 || totalPassenger > 8;
  let t6;
  if ($[14] !== onAdd || $[15] !== t5) {
    t6 = <Button StartIcon={t4} className={styles["add-room"]} color="secondary" disabled={t5} onClick={onAdd} text={add_room} variant="text" />;
    $[14] = onAdd;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t3 || $[18] !== t6) {
    t7 = <div className={styles.main}><div className={styles.list}>{t3}{t6}</div></div>;
    $[17] = t3;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const t8 = adultWarningIsShow || list.length === 6 || totalPassenger > 8 ? "pb-4" : "";
  let t9;
  if ($[20] !== totalPassenger) {
    t9 = totalPassenger > 8 && <MiniChips StartIcon={<MaterialIcon className="text-base" name="info" variant="outlined" />} color="default" text={valid_passenger_count(9)} variant="text" />;
    $[20] = totalPassenger;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== adultWarningIsShow) {
    t10 = adultWarningIsShow && <MiniChips StartIcon={<MaterialIcon className="text-base" name="info" variant="outlined" />} color="default" text={valid_max_adult_count(6)} variant="text" />;
    $[22] = adultWarningIsShow;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== list.length) {
    t11 = list.length === 6 && <MiniChips StartIcon={<MaterialIcon className="text-base" name="info" variant="outlined" />} color="default" text={valid_max_room_count(6)} variant="text" />;
    $[24] = list.length;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t8 || $[29] !== t9) {
    t12 = <div className={t8}>{t9}{t10}{t11}</div>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t8;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== submitButtonProps || $[32] !== submitText) {
    t13 = <Button {...submitButtonProps}>{submitText}</Button>;
    $[31] = submitButtonProps;
    $[32] = submitText;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t12 || $[35] !== t13) {
    t14 = <div className={styles.footer}>{t12}{t13}</div>;
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t14 || $[38] !== t7) {
    t15 = <div className={styles["mini-popover"]}>{t7}{t14}</div>;
    $[37] = t14;
    $[38] = t7;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== popoverProps || $[41] !== t15) {
    t16 = <MiniPopover {...popoverProps}>{t15}</MiniPopover>;
    $[40] = popoverProps;
    $[41] = t15;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== t16 || $[44] !== t2) {
    t17 = <div className={styles["passenger-count"]}>{t2}{t16}</div>;
    $[43] = t16;
    $[44] = t2;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  return t17;
};
function _temp(item_0) {
  return <div key={item_0.title}><ListItem key={item_0.title} {...item_0} /></div>;
}
function _temp2(item_2) {
  return <option key={item_2?.title} value={item_2?.value}>{item_2?.title}</option>;
}